module.exports = __webpack_public_path__ + "static/media/FENGYUN 2F.67df87cd.czml";